import Rellax from 'rellax';
// import simpleParallax from 'simple-parallax-js';
// import Parallax from 'parallax-js'
common.View.create('vacancy::canvas.blocks.custom.vacancyForm.Block', {
    onDOMLoad() {
        // this.initParallax();
    },

    initParallax() {
        // const parallaxBg = this.element.find('.parallaxBg').get(0);
        //
        // new simpleParallax(parallaxBg, {
        //     delay: 0,
        //     orientation: 'down',
        //     scale: 1.5,
        //     overflow: true,
        // });
        //todo: dit werkt gwn niet met meerdere blokken
        new Rellax('.parallaxBg', {
            speed: 3,
            center: false,
            wrapper: null,
            round: true,
            vertical: true,
            horizontal: false
        });
    }
});
